import React from "react"
interface Props {
	type?: string;
	disabled?: boolean;
	name: string;
	label?: string;
	value: string | null;
	onChange: (value: string) => void;
}

interface State {
	currentText: string;
	error?: string;
}

export class ColorInput extends React.Component<Props, State>
{
	private nullColor = "#ffffff";
	constructor(props: Props) {
		super(props);
		this.state = { currentText: props.value || this.nullColor };
	}

	private onChange = (e: React.FormEvent<HTMLInputElement>) => {
		const currentText = (e.target as HTMLInputElement).value;
		this.setState({ currentText, error: "" });
		this.props.onChange(currentText);
	};

	componentDidUpdate(oldProps: Props) {
		if (oldProps.value != this.props.value)
			this.setState({ currentText: this.props.value || this.nullColor });
	}

	render() {

		var label = (<div />);
		if (this.props.label)
			label = <div><label className="form-label" htmlFor={this.props.name}>{this.props.label}</label></div>;

		return (
			<div>
				{label}
				<input type="color"
					style={{ width: "100%", height: 38 }}
					name={this.props.name}
					value={this.state.currentText}
					onChange={this.onChange}
					disabled={this.props.disabled}
				/>
				{this.props.children}
			</div>
		);
	}
}

export default ColorInput;